import * as THREE from 'three';
import { GameScreen } from '../ui/screens/game_screen/game_screen.js';
import { PhysicsTable } from '../entities/physics_table.js';
import RAPIER from '@dimforge/rapier3d-compat';

export enum EntityKind { Cube, Jar, Cone, Metal, Ice, Tree, Watermelon, Door, Flag, ConP }

export interface LevelEntity
{
  readonly kind: EntityKind;
  readonly body: RAPIER.RigidBody;
  readonly collider: RAPIER.Collider;
  readonly mesh: THREE.Object3D;
  readonly size: THREE.Vector3;

  isAlive(): boolean;
  update( dt: number ): void;
  dispose(): void;

  canBeHit(): boolean;
  onBallHit( point: THREE.Vector3 ): void;
  onFireworkHit( point: THREE.Vector3 ): void;
  checkSelfDestruct( dt: number, table: PhysicsTable ): void;

  isAtRest?(): boolean;

  /**
   * True while the entity is dead for gameplay but still on screen — a plastic
   * cube lying on the ground before its alpha fade. Cleanup keeps such a body
   * around (it no longer counts toward the level) until this turns false.
   */
  keepCorpse?(): boolean;

  hasPhysicsBody?(): boolean;
}
